import React, { useState } from "react";
import { Box, Button, TextField, Typography, useMediaQuery, Divider, Card, CardContent, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useAuth } from "../../context/authContext";
import Swal from "sweetalert2";
import "./Support.css";
import customHttp from "../../services/customHTTP";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

const Support = () => {
	const navigate = useNavigate();
	const isMobile = useMediaQuery("(max-width:600px)");
	const { user } = useAuth();
	const [ticketFormVisible, setTicketFormVisible] = useState(false);
	const [statusFormVisible, setStatusFormVisible] = useState(false);
	const [fileData, setFileData] = useState(null);

	const [formData, setFormData] = useState({
		email: user?.user_email || "",
		fullname: user?.user_display_name || "",
		phone: user?.user_phone || "",
		subject: "",
		message: "",
	});

	const [supportFormData, setSupportFormData] = useState({
		ticket_number: "",
	});

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = () => {
				setFileData({
					name: file.name,
					type: file.type,
					data: reader.result.split(",")[1], // Remove data:*/*;base64, prefix
				});
			};
			reader.readAsDataURL(file);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const req_body = {
			name: formData.fullname,
			email: formData.email,
			phone: formData.phone,
			subject: formData.subject,
			message: formData.message,
			attachment: fileData,
		};
		try {
			const response = await customHttp.post("support/send-email", req_body);
			if (response.data.status === "success") {
				setFormData({
					email: user?.user_email || "",
					fullname: user?.user_display_name || "",
					phone: user?.user_phone || "",
					subject: "",
					message: "",
				});
				setFileData(null);
				Swal.fire({
					icon: "success",
					title: "Success",
					text: "A Customer Care representative will be in contact with you shortly!",
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleTicketFormOpen = () => {
		setTicketFormVisible(true);
		setStatusFormVisible(false);
	};

	const handleStatusFormOpen = () => {
		setStatusFormVisible(true);
		setTicketFormVisible(false);
	};

	return (
		<Box sx={{ padding: isMobile ? 2 : 5, width: isMobile ? "100vw" : "60vw" }}>
			<PageTitle title="Support" />
			<div className="support-text">
				<Typography variant="body1" textAlign={"center"}>
					Need parts for your BPA system? We are your single point of contact. Do you have a spare part
					inquiry?
				</Typography>
			</div>

			<Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={3}>
				<Card className="support-card">
					<CardContent>
						<Typography variant="h6">Support</Typography>
						<Box className="card-divider"></Box>
						{/* <Typography variant="body1" fontWeight="bold">
							Tech Support:
						</Typography> */}
						<Link href="tel:(804) 520-5400" underline="hover" color="#000">
							<Typography variant="body2" fontWeight="bold">
								+1 (804) 520-5400
							</Typography>
						</Link>
						{/* <Link href="tel:(303) 682-2100" underline="hover" color="#000">
							<Typography variant="body2">+1 (303) 682-2100</Typography>
						</Link> */}

						{/* <Typography variant="body1" fontWeight="bold" mt={2}>
							24 Hr Support:
						</Typography>
						<Link href="tel:(804) 520-5400" underline="hover" color="#000">
							<Typography variant="body2">+1 (804) 520-5400</Typography>
						</Link> */}
						<Typography variant="body1" fontWeight="bold" mt={2}>
							For North and South America mail:
						</Typography>
						<Link href="mailto:orders@blueprintautomation.com" underline="hover" color="#000">
							<Typography variant="body2">orders@blueprintautomation.com</Typography>
						</Link>
					</CardContent>
				</Card>

				{/* <Card className="support-card">
					<CardContent>
						<Typography variant="h6">Ticket Status</Typography>
						<Box className="card-divider"></Box>
						<Typography variant="body2">Track and manage customer issues efficiently.</Typography>

						<Button variant="contained" color="primary" sx={{ mt: 6 }} onClick={handleStatusFormOpen}>
							Check Status
						</Button>
					</CardContent>
				</Card> */}

				<Card className="support-card">
					<CardContent
						sx={{
							display: "flex",
							justifyContent: "space-between",
							flexDirection: "column",
							alignItems: "flex-start",
							height: "100%",
						}}>
						<Box sx={{ width: "100%" }}>
							<Typography variant="h6">Contact</Typography>
							<Box className="card-divider"></Box>
						</Box>
						<Typography variant="body2">
							Have a spare part inquiry, submit the contact form below
						</Typography>
						<Button variant="contained" color="primary" sx={{ mt: 6 }} onClick={handleTicketFormOpen}>
							Contact Us
						</Button>
					</CardContent>
				</Card>
			</Box>
			{ticketFormVisible && (
				<Box mt={4}>
					<Typography variant="h6" fontWeight={"bold"} mb={1}>
						Contact Us
					</Typography>
					<Box className="card-divider"></Box>
					<form onSubmit={handleSubmit} style={{ marginTop: "15px" }}>
						<TextField
							fullWidth
							label="Email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							sx={{ mb: 2, mt: 2 }}
						/>
						<TextField
							fullWidth
							label="Full Name"
							name="fullname"
							value={formData.fullname}
							onChange={handleChange}
							sx={{ mb: 2 }}
						/>
						<TextField
							fullWidth
							label="Phone"
							name="phone"
							value={formData.phone}
							onChange={handleChange}
							sx={{ mb: 2 }}
						/>
						<TextField
							fullWidth
							label="Subject"
							name="subject"
							value={formData.subject}
							onChange={handleChange}
							sx={{ mb: 2 }}
						/>
						<TextField
							fullWidth
							multiline
							rows={4}
							label="Message"
							name="message"
							value={formData.message}
							onChange={handleChange}
							sx={{ mb: 2 }}
						/>
						<Box display="flex" flexDirection="column" gap={1}>
							<Button
							component="label"
							role={undefined}
							variant="outlined"
							tabIndex={-1}
							startIcon={<CloudUploadIcon />}
							sx={{ mb: 1, width: "fit-content" }}
							>
							Upload File
							<VisuallyHiddenInput type="file" onChange={handleFileChange} />
							</Button>
							{fileData && (
							<Typography variant="body2" sx={{ mb: 1 }}>
								Selected: {fileData.name}
							</Typography>
							)}
							<Button type="submit" variant="contained" color="primary" sx={{ width: "fit-content" }}>
							Submit
							</Button>
						</Box>
					</form>
				</Box>
			)}
		</Box>
	);
};

export default Support;